import { render, staticRenderFns } from "./DictManagement.vue?vue&type=template&id=4f3b4ff0&scoped=true"
import script from "./DictManagement.vue?vue&type=script&lang=js"
export * from "./DictManagement.vue?vue&type=script&lang=js"
import style0 from "./DictManagement.vue?vue&type=style&index=0&id=4f3b4ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3b4ff0",
  null
  
)

export default component.exports